import React from 'react';
export function Footer() {
  return <footer className="bg-[#3D2B1F] text-[#FAF7F4] py-8 border-t border-[#5C4230]" data-id="element-120">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-121">
        <div className="text-center md:text-left" data-id="element-122">
          <h3 className="text-2xl font-serif font-bold mb-2" data-id="element-123">
            Biblioteca Crochet
          </h3>
          <p className="text-[#B09B8C] text-sm" data-id="element-124">
            © 2026 La Biblioteca Total de Crochet. Todos los derechos
            reservados.
          </p>
        </div>

        <div className="flex gap-6 text-sm text-[#B09B8C]" data-id="element-125">
          <a href="#" className="hover:text-[#D4A5A5] transition-colors" data-id="element-126">
            Términos
          </a>
          <a href="#" className="hover:text-[#D4A5A5] transition-colors" data-id="element-127">
            Privacidad
          </a>
          <a href="#" className="hover:text-[#D4A5A5] transition-colors" data-id="element-128">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}